import React, { useEffect, useState } from 'react'
import { useZocksAuth } from '../../components/ScopedBlock/hooks'
import { Col, Container, Row } from 'react-bootstrap'
import { Button } from '../../components/Button/Button'
import { useGetAccountQuery } from '../../store/accountUserSettings/accountUserSettings'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { MissingScopeAction } from '../../components/ScopedBlock/models'
import { ScopedBlock } from '../../components/ScopedBlock/ScopedBlock'

export interface GrantCrossAccountAccessProps {
  onGrantAccess: () => void
}

export const GrantCrossAccountAccessCta: React.FC<GrantCrossAccountAccessProps> = ({ onGrantAccess }) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: account } = useGetAccountQuery({ accountId })
  const [crossAccountAccessIsEnabled, setCrossAccountAccessIsEnabled] = useState(false)
  const { hasScope } = useZocksAuth()
  const hasStartSessionScope = hasScope('**', 'room_session:start', ['room_session:admin', 'room:admin'])

  useEffect(() => {
    if (account) {
      setCrossAccountAccessIsEnabled(account.data.effectiveConfig.crossAccountAccess)
    }
  }, [account])

  if (!hasStartSessionScope) {
    return null
  }
  return (
    <Container fluid className='mb-2 mb-md-0 border zocks-border-color-primary zocks-border-0.25'>
      <Row className='justify-content-between align-items-center p-4'>
        <Col xs={12} sm={12} md={8} className='p-0 w-auto'>
          <Container fluid className='p-0 d-flex align-items-center'>
            <Row>
              <Col className='d-flex flex-column justify-content-center overflow-hidden'>
                <Row className='mb-2'>
                  <Col>
                    <h5>Grant cross-account access</h5>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div>You can grant cross-account access to members of other Zocks accounts, allowing them to join your team.</div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Col>
        <Col xs={12} sm={12} md='auto' className='py-3 p-md-0 d-flex justify-content-center align-items-center'>
          <div className='view-meeting-btn'>
            <ScopedBlock scope={{ scope: 'consoleuser:invite', superScope: ['consoleuser:admin'] }} missingScopeAction={MissingScopeAction.DISABLE}>
              <Button
                variant='primary'
                onClick={onGrantAccess}
                disabled={!crossAccountAccessIsEnabled}
                title={!crossAccountAccessIsEnabled ? 'Cross-account access is not enabled' : ''}
              >
                <i className='bi bi-plus' />
                Grant access
              </Button>
            </ScopedBlock>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
